import React, { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { BILL_PAY, EXPERIMENTS } from '~/constants'
import useCookieYes from '~/hooks/useCookieYes'
import { useSignupDynamicHeadlineBillsExperiment } from '~/hooks/useSignupDynamicHeadlineBillsExperiment'
import { useExperiment } from '~/hooks/useExperiment'

import SignUpV2 from '~/pages/Signup/SignUpV2'

import './styles.scss'

const Signup = () => {
  useCookieYes()

  const [searchParams] = useSearchParams()
  const promoCodeFromURL = searchParams.get('promo_code')
  const utmMediumParam = searchParams.get('utm_medium')

  const { enabled: isPrimeGuarantee } = useExperiment(EXPERIMENTS.PRIME_3_MONTH_GUARANTEE)

  const determinePromoCode = useMemo(() => {
    if (promoCodeFromURL) {
      return promoCodeFromURL
    }

    if (utmMediumParam === BILL_PAY) {
      return null
    }

    return ''
  }, [promoCodeFromURL, utmMediumParam])

  const headline = useSignupDynamicHeadlineBillsExperiment(utmMediumParam)

  return (
    <SignUpV2
      headline={headline}
      promoCode={determinePromoCode}
      isPrimeGuarantee={isPrimeGuarantee}
    />
  )
}

const Memoized = React.memo(Signup)
export default Memoized
